import React, { useState, useEffect } from "react";
import { Form, Button, Container, Row, Col, Card } from "react-bootstrap";
import Modal from "react-bootstrap/Modal";
import "./UsersManagement.css";
import axios from "../../util/Axios/AxiosInstance";
import { API_URL } from "../../util/Constants";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import "react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css";
import "bootstrap/dist/css/bootstrap.min.css";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import * as ReactBootStrap from "react-bootstrap";
import filterFactory, { textFilter } from "react-bootstrap-table2-filter";
import "react-bootstrap-table2-filter/dist/react-bootstrap-table2-filter.min.css";
import AOS from "aos";
import "aos/dist/aos.css";
import edit from "../../../images/edit.png";
import TableActionIcon from "../../util/TableActionIcon";

function UsersManagementDataTable({ HandleEvent, HandleEventGetId }) {
    const [tableData, setTableData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [pageNumber, setPageNumber] = useState(1);
    const [pageSize, setPageSize] = useState(10);

    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleOpen = () => setShow(true);
    const [branch, setBranch] = useState(localStorage.getItem("branch"));
    const [branchId, setBranchId] = useState(localStorage.getItem("branchId"));
    const [emailId, setEmailId] = useState("");
    const [userName, setUserName] = useState("");
    const [password, setPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [role, setRole] = useState("");
    const [contractName, setContractName] = useState("");
    const [vendorId, setVendorId] = useState("");
    const [vendorName, setVendorName] = useState("");
    const [error, setError] = useState("");
    const [roleList, setRoleList] = useState([{id: "", role: ""},]);
    const [vendorList, setVendorList] = useState([{id: "", vendorName: "", contractName: ""},]);
    const [vendorAccount, setVendorAccount] = useState(false);

    const getUserRolesByBranchId = async (branchId) => {
        try {
            const data = await axios.get(
                "getUserRolesByBranchId/" + branchId
            );
            setRoleList(data.data);
        } catch (e) {}
    };
    
    const getVendorDetailsByBranchId = async (branchId) => {
      try {
          const data = await axios.get(
              "getVendorMasterDetailsByBranchId/" + branchId
          );
          setVendorList(data.data);
      } catch (e) {}
    };
    
    const getVendorDetails = (e) => {
    
    };
    
    const errorCheck =(e) => {
        if(role == "defaultOption" || vendorName == "defaultOption" || userName.trim().length == 0 || emailId.trim().length <= 0 || password.trim().length <= 0 || confirmPassword.trim().length <= 0 || confirmPassword.trim().length !== password){
            setError(true);
        }
    }

    const updateRole = (e) => {
      setRole(e.target.value);
      if(e.target.value == 'Vendor'){
        setVendorAccount(true);
      }
      else{
        setVendorAccount(false);
        setVendorId("");
        setVendorName("");
      }
    };
    
      useEffect(() => {
        if(show == true){
        getUserRolesByBranchId(branchId);
        }
      }, [show])
    
      useEffect(() => {
        if(role == 'Vendor'){
          setVendorAccount(true);
          getVendorDetailsByBranchId(branchId);
        }
      },[role])

    const options = {
        onSizePerPageChange: (sizePerPage, page) => {
            setPageSize(sizePerPage);
        },
        onPageChange: (page, sizePerPage) => {
            setPageNumber(page);
        },
    };
    const getUserDataByBranchId = async (branchId) => {
        try {
            const data = await axios.get(
                 "getUserDetailsByBranchId/" + branchId
            );
            setTableData(data.data);

            setLoading(true);
        } catch (e) {}
    };

    useEffect(() => {
        AOS.init();
        const branchId = localStorage.getItem("branchId");
        getUserDataByBranchId(branchId);
    }, []);

    const updateStatus = (row) => {
        if (row.status) {
            row.status = 0;
        } else {
            row.status = 1;
        }
        const url = API_URL + "updateVendorMasterDetails";
        fetch(url, {
            method: "PUT",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
            },
            body: JSON.stringify(row),
        }).then((result) => {
            result.json().then((resp) => {

            });
        });
    };

    const columns = [
        {
            dataField: "id",
            text: "S No.",
            formatter: (cell, row, rowIndex) => {
                return (pageNumber - 1) * pageSize + (rowIndex + 1);
            },
            headerStyle: (colum, colIndex) => {
                return { width: "60px", textAlign: "center" };
            },
        },
        { dataField: "emailId", text: "Email Id" , filter: textFilter(), sort: true,},
        {
            dataField: "userName",
            text: "User Name",
            sort: true,
            filter: textFilter(),
        },
        {
            dataField: "role",
            text: "Role",
            sort: true,
            filter: textFilter(),
        },
        {
            dataField: "status",
            text: "Status",
            formatter: (cellContent, row) => {
                return (
                    <Form.Check
                        type="switch"
                        id="custom-switch"
                        defaultChecked={cellContent}
                        onClick={() => updateStatus(row)}
                    ></Form.Check>
                );
            },
        },
        {
            dataField: "branch_name",
            text: "Edit",
            isDummyField: true,
            formatter: (cellContent, row) => {
                return (
                    <TableActionIcon
                        src={edit}
                        title="Edit user"
                        onClick={() => HandleEventGetId(12, row)}
                    />
                );
            },
        },
    ];

    return (
        <Card className="cardStyl">
            <Container fluid className="px-0">
                <div className={"mt-2"}>
                    <h5 className={"priColor"}>Users List</h5>
                </div>
                <div>
                    <div className={"row"}>
                        <div style={{ marginBottom: "10px" }}>
                            <button
                                className={"btn btn-primary"}
                                variant="primary"
                                style={{ float: "right" }}
                                onClick={(e) => handleOpen()}
                            >
                                Create User
                            </button>
                        </div>
                    </div>
                    {loading ? (
                        <div data-aos="zoom-in-right" data-aos-duration="550">
                            <BootstrapTable
                                bootstrap4
                                keyField="id"
                                data={tableData}
                                columns={columns}
                                wrapperClasses="table-responsive"
                                pagination={paginationFactory(options)}
                                filter={filterFactory()}
                            />
                        </div>
                    ) : (
                        <ReactBootStrap.Spinner animation="border" />
                    )}
                </div>
                <div>
                <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Manage Users</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>

          <Row className="mb-3">
          <Form.Label column md={6} lg={6} sm={6} xl={6}>Role</Form.Label>
          <Col><Form.Select onChange={(e) => updateRole(e)}>
            <option key={"defaultOption"} value={"defaultOption"}>Select Role</option>
            {roleList.map(ListRole => (
                            <option
                              key={ListRole.id}
                              value={ListRole.role}
                              id={ListRole.role}
                            >
                              {ListRole.role}
                            </option>
                          ))}
                        </Form.Select>
                        {error&& (role == "defaultOption")?
                        <label className="requiredValidation">Please Select Role </label>:""}
                        </Col>
                        </Row>

          <Row hidden= {!vendorAccount} className="mb-3">
          <Form.Label  column md={6} lg={6} sm={6} xl={6}>Vendor</Form.Label>
          <Col><Form.Select hidden= {!vendorAccount} onChange={(e) => getVendorDetails(e)}>
            <option key={"defaultOption"} value={"defaultOption"}>Select Vendor</option>
            {vendorList.map(vendorDetails => (
                            <option
                              key={vendorDetails.id}
                              value={vendorDetails.vendorName}
                              id={vendorDetails.contractName}
                            >
                              {vendorDetails.vendorName}
                            </option>
                          ))}
                        </Form.Select>
                        {error&& (vendorName == "defaultOption") && vendorAccount == true?
                        <label className="requiredValidation">Please Select Vendor </label>:""}
          </Col>
          </Row>

          <Row className="mb-3">
          <Form.Label column md={6} lg={6} sm={6} xl={6}>Username</Form.Label>
          <Col><Form.Control type="text" placeholder="Enter here.." autoFocus
          onChange={(e) => setUserName(e.target.value)} value={userName}
                            />
                            {error && userName.trim().length <= 0 ? (
                                <label className="requiredValidation">
                                  Username Can't be empty
                                </label>
                            ) : (
                                ""
                            )}
            </Col>
            </Row>
            
            <Row className="mb-3">
              <Form.Label column md={6} lg={6} sm={6} xl={6}>Email address</Form.Label>
              <Col><Form.Control
                type="email"
                placeholder="name@example.com"
                onChange={(e) => setEmailId(e.target.value)} value={emailId}
              />
            {error && emailId.trim().length <= 0 ?
            (<label className="requiredValidation"> Email Can't be Empty</label>) : (" ")}
            </Col>
            </Row>

            <Row className="mb-3">
              <Form.Label column md={6} lg={6} sm={6} xl={6}>Password</Form.Label>
              <Col><Form.Control
                type="password"
                placeholder="password"
                onChange={(e) => setPassword(e.target.value)} value={password}
              />
            {error && password.trim().length <= 0 ?
            (<label className="requiredValidation"> Password Can't be Empty</label>) : (" ")}
            </Col>
            </Row>

            <Row className="mb-3">
              <Form.Label column md={6} lg={6} sm={6} xl={6}>Confirm Password</Form.Label>
              <Col>
              <Form.Control
                type="password"
                placeholder="password"
                onChange={(e) => setConfirmPassword(e.target.value)} value={confirmPassword}
              />
            {error && confirmPassword.trim().length <= 0 ?
            (<label className="requiredValidation"> Can't be Empty </label>) : (" ")}
            {error && confirmPassword.trim().length !== password ?
            (<label className="requiredValidation"> Not Matching with the Password </label>) : (" ")}
            </Col>
            </Row>


          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
          <Button variant="primary" onClick={errorCheck}>
            Save Changes
          </Button>
        </Modal.Footer>
      </Modal>
                </div>
            </Container>
        </Card>
    );
}

export default UsersManagementDataTable;
